<template>
    <div>
        大屏设置
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>

</style>